import {
  BackendMinimalBrainForUser,
  MinimalBrainForUser,
} from "@/lib/context/KnowledgeBaseProvider/types";

export const mapBackendMinimalBrainToMinimalBrain = (
  backendMinimalBrain: BackendMinimalBrainForUser,
): MinimalBrainForUser => ({
  id: backendMinimalBrain.id,
  name: backendMinimalBrain.name,
  status: backendMinimalBrain.status,
  brain_type: backendMinimalBrain.brain_type,
  type: backendMinimalBrain.type,
  description: backendMinimalBrain.description,
  integration_logo_url: backendMinimalBrain.integration_logo_url,
  max_files: backendMinimalBrain.max_files,
  allow_model_change: backendMinimalBrain.allow_model_change,
  image_url: backendMinimalBrain.image_url,
  display_name: backendMinimalBrain.display_name,
  snippet_emoji: backendMinimalBrain.snippet_emoji,
  snippet_color: backendMinimalBrain.snippet_color,
  created_at: backendMinimalBrain.created_at,
  updated_at: backendMinimalBrain.updated_at,
  documents_count: backendMinimalBrain.documents_count,
});
